// firebase.ts - Authentication functions
import { initializeApp } from "firebase/app";
import { getAuth, signOut as firebaseSignOut, onAuthStateChanged, updateProfile as firebaseUpdateProfile, applyActionCode, } from "firebase/auth";
import { initializeFirestore, memoryLocalCache, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { firebaseConfig } from "../config/firebase.config";
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Initialize Firestore with optimized settings to reduce connection overhead
// This maintains all functionality (offline caching, real-time listeners, multi-tab sync)
// while reducing unnecessary heartbeat requests on the persistent WebSocket connection
// If IndexedDB is corrupted (e.g., after "Clear site data"), fall back to an
// in-memory cache so the app keeps working instead of crashing on load.
export const db = (() => {
    try {
        return initializeFirestore(app, {
            localCache: persistentLocalCache({
                tabManager: persistentMultipleTabManager(),
            }),
            experimentalAutoDetectLongPolling: true,
        });
    }
    catch (error) {
        const firebaseError = error;
        console.warn("Firestore persistent cache unavailable, falling back to memory cache.", firebaseError);
        return initializeFirestore(app, {
            localCache: memoryLocalCache(),
            experimentalAutoDetectLongPolling: true,
        });
    }
})();
export const storage = getStorage(app);
// Get current user
export const getCurrentUser = () => {
    return auth.currentUser;
};
// Auth state change observer
export const onAuthStateChange = (callback) => {
    return onAuthStateChanged(auth, callback);
};
// Export the auth functions to be implemented by secureAuthUtils
export { firebaseSignOut, firebaseUpdateProfile, applyActionCode };
